import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProfileData } from '../types/profile';

export interface ProfileState  {
  data: ProfileData | null;
  isFetching: boolean;
  loaded: boolean;
  error: boolean;
}

export const initialState: ProfileState = {
  data: null,
  isFetching: false,
  loaded: false,
  error: false
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    fetchProfileRequested: state => {
      state.isFetching = true;
      state.loaded = false;
    },
    profileReceived: (state, action: PayloadAction<ProfileData>) => {
      state.isFetching = false;
      state.loaded = true;
      state.data = action.payload;
    },
    receiveProfileError: state => {
      state.isFetching = false;
      state.loaded = true;
      state.error = true;
    }
  }
})

export const actions = profileSlice.actions;

export default profileSlice.reducer;
